import React, { useState, useRef, useEffect, MouseEvent } from 'react';
import { Box, BoxProps, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { SparkFormCodeTextFieldProps } from 'sharedComponents/SparkForm/SparkFormCodeTextField';
import NodeCodePanel from './NodeCodePanel';
import { useCurrentRoute } from 'hooks/common';

const MIN_WIDTH = 40;
const MAX_WIDTH = 600;
const OPEN_WIDTH = 200;
type NodeWithCodePanelWrapperProps = {
  children: React.ReactNode;
  onChange: (value: string) => void;
  initialContent: string;
  readOnly?: boolean;
  language?: SparkFormCodeTextFieldProps['language'];
  boxStyles?: BoxProps['sx'];
};

const NodeWithCodePanelWrapper = ({
  children,
  onChange,
  initialContent,
  readOnly,
  language,
  boxStyles = {},
}: NodeWithCodePanelWrapperProps) => {
  const [panelWidth, setPanelWidth] = useState<number>(OPEN_WIDTH);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isDragging, setIsDragging] = React.useState<boolean>(false);
  const [error, setError] = React.useState<Error | null>(null);
  const { isSparkRunDetails, isSparkRun } = useCurrentRoute();
  const handleMouseDown = () => {
    setIsDragging(true);
  };
  const handleMouseMove = React.useCallback(
    (e: MouseEvent | globalThis.MouseEvent) => {
      if (isDragging) {
        const containerLeft =
          containerRef.current?.getBoundingClientRect().left || 0;
        const newWidth = Math.min(
          Math.max(e.clientX - containerLeft, MIN_WIDTH),
          MAX_WIDTH
        );
        setPanelWidth(newWidth);
      }
    },
    [isDragging]
  );

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [handleMouseMove]);

  // const toggleCollapse = () => {
  //   setIsCollapsed((prev) => {
  //     if (prev) {
  //       setPanelWidth(OPEN_WIDTH);
  //     }
  //     return !prev;
  //   });
  // };

  // const handleError = (error: Error | null) => {
  //   setError(error);
  // };
  return (
    <Box
      sx={{
        display: 'flex',
        overFlow: 'hidden',
        width: '100%',
        position: 'relative',
        // maxHeight: '20rem',
        minHeight: '10rem',
        overflow: 'hidden',
      }}
    >
      {/* {!isSparkRunDetails && !isSparkRun && (
        <Box
          ref={containerRef}
          sx={{
            width: isCollapsed ? MIN_WIDTH : panelWidth,
            backgroundColor: '#f4f4f4',
            display: 'flex',
            alignItems: 'center',
            borderRight: (theme) => `1px solid ${theme.palette.borderColor}`,
            position: 'relative',
            transition: isDragging ? 'none' : 'width 0.3s ease',
            bgcolor: 'white',
          }}
        >
          <Box
            className='node-code-panel'
            sx={{
              maxHeight: '20rem',
              overflowY: 'scroll',
              scrollbarWidth: 'none',
              bgcolor: 'white',
              width: '100%',
              height: '100%',
            }}
          >
            <NodeCodePanel
              onChange={onChange}
              initialContent={initialContent}
              readOnly={readOnly}
              language={language}
              name={''}
              label={undefined}
              width='100%'
              handleError={handleError}
            />
          </Box>

          {!isCollapsed && (
            <Box
              onMouseDown={handleMouseDown}
              sx={{
                width: '2px',
                cursor: 'col-resize',
                backgroundColor: (theme) => theme.palette.borderColor,
                position: 'absolute',
                right: 0,
                height: '100%',
                '& hover': {
                  backgroundColor: (theme) => theme.palette.primary.main,
                },
              }}
            />
          )}
          <IconButton
            size='small'
            onClick={toggleCollapse}
            sx={{
              position: 'absolute',
              right: '-18px',
              top: 20,
              transform: 'translateY(-50%)',
              bgcolor: 'white',
              border: (theme) => `1px solid ${theme.palette.borderColor}`,
              zIndex: 6,
              '&:hover': {
                bgcolor: 'white',
                borderColor: (theme) => theme.palette.primary.main,
              },
            }}
          >
            {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
          </IconButton>
        </Box>
      )} */}
      <Box
        sx={{
          flex: 1,
          bgcolor: 'white',
          overflow: 'hidden',
          zIndex: 4,
          // maxHeight: '20rem',
          paddingX: 2,
          ...boxStyles,
        }}
      >
        {children}
      </Box>
      {error && (
        <Box
          position='absolute'
          bgcolor={(theme) => theme.palette.error.light}
          bottom={0}
          right={0}
          left={0}
          sx={{ zIndex: 2000 }}
          display='flex'
          alignItems='center'
          padding={2}
        >
          <Typography>{error.message}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default NodeWithCodePanelWrapper;
